// based on rc-pagination 1.20.14
export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-pagination/index.js
// module id = 835
// module chunks = 0